/**
 * Ryan O'Dowd
 * 2024-10-02
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({colors}) => {
  return {
    errorMessage: {
      color: colors.alert,
    },
  };
};

export default getStyles;
